/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content",
  value,
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TableX
  viewPath={`${viewPath}/TableX`}
 virtual={true}
 enableRowSelection={true}
 value={value}
 onChange={onChange}
 fontSize={12}
 heightRow={47}
 rightBorder={1}
 borderLeftWidthHeader={0}
 borderRightWidthHeader={1}
 borderRightStyleHeader="solid"
 borderRightColorHeader="#E4E7EB"
 borderBottomColor="#E4E7EB"
/>
</div>
{children}
</React.Fragment>)
}